import { render, staticRenderFns } from "./ActionLinksPage.vue?vue&type=template&id=7f9c3d2f&"
import script from "./ActionLinksPage.vue?vue&type=script&lang=js&"
export * from "./ActionLinksPage.vue?vue&type=script&lang=js&"
import style0 from "./ActionLinksPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VDialog,VSkeletonLoader})
